<script setup>
import { frames } from '../../../../utils/frames'
const gsapTimeline = useGsapTimeline()

const containerElement = ref(null)

const start = async () => {
  await gsapTimeline({ name: 'Reveal' }).fromTo(containerElement, { opacity: 0 }, { opacity: 1, duration: frames(24, 50), ease: 'power1.out' }, 0)
}

const { manualStart } = defineProps({
  manualStart: { type: Boolean, default: false },
})

onMounted(() => {
  if (!manualStart) {
    start()
  }
})

defineExpose({ start })
</script>

<template>
  <div ref="containerElement" class="w-full h-full opacity-0">
    <slot />
  </div>
</template>
